// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__2Zbnv","valueCheck":"Param_valueCheck__1ZNX8","valueCross":"Param_valueCross__1sM-Y"};